var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-12"},[_c('MailsDataTable',{attrs:{"loading":_vm.loading,"mails":_vm.mails,"total":_vm.total,"allowed-page":true,"allowed-unit-page":true},on:{"update":_vm.onUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }